import React from 'react';
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

type PropTypes = { open: boolean; handleClose: () => void };

const MenuHeader = ({ open, handleClose }: PropTypes) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        py: theme.spacing(1.5),
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="h4" ml={3} fontSize={theme.spacing(3)}>
        {t('aiMusicGenerator:infoGuide.helpGuide')}
      </Typography>
      <IconButton
        sx={{
          mr: theme.spacing(1),
          color: theme.palette.grey[200],
        }}
        size="medium"
        aria-controls={open ? 'close-info-guide-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default MenuHeader;
